import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardModule } from '@dashboard/dashboard.module';
import { DashboardComponent } from '@dashboard/dashboard.component';
import { ErrorPageComponent, PageNotFoundComponent } from './features';
import { WizardComponent } from './features/wizard/wizard.component';
import { SpAuthGuard } from '@core/guards/auth-guard';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'account-management',
    loadChildren: () =>
      import('@accountManagement/account-management.module').then(
        module => module.AccountManagementModule
      ),
    canActivate: [SpAuthGuard],
  },
  {
    path: 'account-management/:child-page',
    loadChildren: () =>
      import('@accountManagement/account-management.module').then(
        module => module.AccountManagementModule
      ),
  },
  {
    path: 'change-password',
    loadChildren: () =>
      import('@changePassword/change-password.module').then(module => module.ChangePasswordModule),
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'paystubs',
    loadChildren: () => import('@paystubs/paystubs.module').then(module => module.PaystubsModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('@profile/profile.module').then(module => module.ProfileModule),
  },
  {
    path: 'tax-forms',
    loadChildren: () => import('@taxforms/tax-forms.module').then(module => module.TaxFormsModule),
  },
  //////////////////////////////////
  //! Not Lazy Loaded
  { path: 'personal/:editPageMode', component: WizardComponent },
  { path: 'address/:editPageMode', component: WizardComponent },

  {
    path: 'error-page',
    component: ErrorPageComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  //* Scroll to top of page on route transition...........................v
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    DashboardModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
